module.exports = __webpack_public_path__ + "img/dred-sam-scott.4aa66cc9.png";